module.exports = __webpack_public_path__ + "static/bg-wall-f82dfb22cd1266df0ff35a6a7a506cd6.png";